(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/feature-toggle.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/feature-toggle.js');
"use strict";


const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const logger = getLogger('lb-utils:api-proxy:feature-toggle');

const featureToggle = async (toggle, options) => {
  let isEnabled = false;
  try {
    if (svs.isServer) {
      if (!options.req) {
        throw new Error('Request object is required in options when running on server');
      }
      isEnabled = await options.req.feature(toggle);
    } else {
      isEnabled = trinidad.detect.feature(toggle);
    }
  } catch (error) {
    logger.error("Error checking feature toggle \"".concat(toggle, "\":"), error);
  }
  logger.debug("Feature toggle \"".concat(toggle, "\" is ").concat(isEnabled ? 'enabled' : 'disabled', " isBoolean: ").concat(typeof isEnabled === 'boolean'));
  return isEnabled;
};
if (svs.isServer) {
  module.exports = featureToggle;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.featureToggle', featureToggle);
}

 })(window);